import http from './request'

/**
 * 通过品牌和站点绑定邮箱和cart值
 * @param {Object} params
 * @returns
 */
export const addCart = (params) => {
  return http.post(`/public/chatwoot/cart/add`, params)
}
